<template>
  <!-- 短视频投后数据报告 -->
  <div>
    <contenr/>
    <div class="page">
    <div :class="setTop?'left_part_top':'left_part'">
      <template >
        <a class="left_part_text" v-for="(item,index) in leftPartArr" :key="item.name"  @click="leftPart(item.href,index)" :class="leftPartIndex == index?'left_part_active':''" :style="item.hide == true?'display: none;':''"><span>{{ item.name }}</span></a>
      </template>
    </div>
    <div class="detailContainer">
      <div class="part part1">
        <span class="topName">投后数据报告</span>
        <div class="infoText orderInfo">订单号：{{ cooperate.sericnum ||'-'}} | 发布时间：{{ cooperate.release_at||'-'}}</div>

        <div class="infoContent">
          <a class="backImg" :href="baseInfo.basicInfo?.order_info[0].item_info.url||''" target="_blank">
              <img :src="`https://p3-star.byteimg.com/img/${baseInfo.basicInfo?.order_info[0].item_info.item_cover}~tplv-resize:400:0.webp`" alt="">
          </a>
          <div class="contentDetail">
            <div class="contentTitle">{{baseInfo.basicInfo?.order_info[0].item_info.title||'-'}}</div>
            <div class="infoText">发布时间：{{create_timestamp||'-'}}│任务ID：{{baseInfo.basicInfo?.order_info[0].order_id||'-'}}│行业：{{baseInfo.basicInfo?.order_info[0].industry_name||'-'}}│组件：{{ baseInfo.component || '-' }}</div>
            <div class="contentBottom">
              <div class="infoItem">
                <div>千次播放成本</div>
                <div class="account">{{fmt(baseInfo.basicInfo?.cpm, {micrometer: true})||'-' }}</div>
                <div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.cpm_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div>
              </div>
              <div class="infoItem">
                <div>互动成本</div>
                <div class="account">{{ fmt(baseInfo.basicInfo?.cpe, {micrometer: true})||'-' }}</div>
                <div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.cpe_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div>
              </div>
              <div class="infoItem">
                <div>点击率</div>
                <div class="account">{{ fmt(baseInfo.basicInfo?.ctr/100, {micrometer: true})||'-' }}</div>
                <div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.ctr_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div>
              </div>
              <div class="infoItem">

                <el-dropdown trigger="click" @command="infoChange">
                  <span class="el-dropdown-link">
                    <span style="font-size: 16px;">{{ infoTitle }}</span><i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="APP安装完成成本">APP安装完成成本</el-dropdown-item>
                    <el-dropdown-item command="线索成本">线索成本</el-dropdown-item>
                    <el-dropdown-item command="千次播放GMV">千次播放GMV</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <template v-if="infoTitle=='APP安装完成成本'">
                  <div class="account">{{ fmt(baseInfo.basicInfo?.cpa, {micrometer: true})||'-' }}</div>
                  <div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.cpa_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div>
                </template>
                <template v-if="infoTitle=='线索成本'">
                  <div class="account">{{ fmt(baseInfo.basicInfo?.gpm, {micrometer: true})||'-' }}</div>
                  <div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.gpm_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div>
                </template>
                <template v-if="infoTitle=='千次播放GMV'">
                  <div class="account">{{ fmt(baseInfo.basicInfo?.cpl, {micrometer: true})||'-' }}</div>
                  <div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.cpl_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div>
                </template>
              </div>
            </div>
          </div>

        </div>
        <div class="grade" id="cooperate">
          <span class="title">合作评价</span>
          <div class="gradeContent">
            <!-- <div class="scort">
              <el-rate
                v-model="cooperate.score"
                disabled
                show-score
                text-color="#ff9900">
              </el-rate>
            </div> -->
            <div class="tags2">
              <div class="tagItem">
                <span>内容质量：</span>
                <img v-if="cooperate.quality==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="cooperate.quality==='需关注'" src="./images/comment2.png" alt=""/>
                <img v-if="cooperate.quality==='很满意'" src="./images/comment3.png" alt=""/>
                <span>{{cooperate.quality}}</span>
              </div>
              <div class="tagItem">
                <span>合作体验：</span>
                <img v-if="cooperate.experience==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="cooperate.experience==='需关注'" src="./images/comment2.png" alt=""/>
                <img v-if="cooperate.experience==='很满意'" src="./images/comment3.png" alt=""/>
                <span>{{cooperate.experience}}</span>
              </div>
              <div class="tagItem">
                <span>数据效果：</span>
                <img v-if="cooperate.effect==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="cooperate.effect==='需关注'" src="./images/comment2.png" alt=""/>
                <img v-if="cooperate.effect==='很满意'" src="./images/comment3.png" alt=""/>
                <span>{{cooperate.effect}}</span>
              </div>
            </div>
          </div>
          <span class="title">评价内容</span>
          <p class="comment">{{cooperate.evaluation?cooperate.evaluation:'无'}}</p>
        </div>
      </div>
      <div class="synthesize" id="synthesize">
        <div class="title">综合表现</div>
        <div class="infoText">从传播表现、种草表现、转化表现三个方面，综合评估视频的营销价值│更新时间: {{ baseInfo.basicInfo?.modify_time }}</div>
        <div class="synthesize_content">
          <div class="title_box"><span class="title">综合表现</span><span class="score">{{ measurement_info.video_score }}<span class="score_text">分</span></span></div>
          <div class="content_box">
            <div class="radar_box">
              <Radar :info="synthesizeRadar"></Radar>
            </div>
            <div class="progress_box">
              <div class="progress_item">
                <span class="progress_title">传播表现</span>
                <el-tooltip  effect="dark" content="基于视预播放、互动、完届幸等教据,评估视频的传播效果" placement="top-start">
                  <i class="el-icon-question" style="margin-left:4px"></i>
                </el-tooltip>
                <el-progress class="progress" :stroke-width=14 :percentage="spread_percentage" :format="()=>{return measurement_info.spread_score + '分'||'-'}" ></el-progress>
              </div>
              <div class="grade_box"><span>较差({{ measurement_info?.spread_interval?.[0]||'-' }}分)</span><span>一般({{ measurement_info?.spread_interval?.[1]||'-' }}分)</span><span>较好({{ measurement_info?.spread_interval?.[2]||'-' }}分)</span><span>优异({{ measurement_info?.spread_interval?.[3]||'-' }}分)</span></div>
              <div class="progress_item">
                <span class="progress_title">种草表现</span>
                <el-tooltip  effect="dark" content="基于视痴观众的搜索、评论等数据,评估视频的种草效果" placement="top-start">
                  <i class="el-icon-question" style="margin-left:4px"></i>
                </el-tooltip>
                <el-progress class="progress" :stroke-width=14 :percentage="seed_percentage" :format="()=>{return measurement_info.seed_score + '分'||'-'}"></el-progress>
              </div>
              <div class="grade_box"><span>较差({{ measurement_info.seed_interval[0]||'-' }}分)</span><span>一般({{ measurement_info.seed_interval[1]||'-' }}分)</span><span>较好({{ measurement_info.seed_interval[2]||'-' }}分)</span><span>优异({{ measurement_info.seed_interval[3]||'-' }}分)</span></div>
              <div class="progress_item">
                <span class="progress_title">转化表现</span>
                <el-tooltip  effect="dark" content="基于转化量、GMV等教据,评估视频的转化效果" placement="top-start">
                  <i class="el-icon-question" style="margin-left:4px"></i>
                </el-tooltip>
                <el-progress class="progress" :stroke-width=14 :percentage="convert_percentage" :format="()=>{return measurement_info.convert_score + '分'||'-'}"></el-progress>
              </div>
              <div class="grade_box"><span>较差({{ measurement_info.convert_interval[0]||'-' }}分)</span><span>一般({{ measurement_info.convert_interval[1]||'-' }}分)</span><span>较好({{ measurement_info.convert_interval[2]||'-' }}分)</span><span>优异({{ measurement_info.convert_interval[3]||'-' }}分)</span></div>
            </div>
          </div>

        </div>
      </div>
      <div class="disseminate" id="disseminate">
        <div class="title">传播表现</div>
        <div class="infoText">基于视频播放、互动、完播率等数据，评价视频的传播效果│更新时间：{{spreadInfo?.modify_time}}</div>
        <div class="disseminate_content">
          <div class="title_box">
            <span class="title">传播量</span>
            <!-- @change="e=>{tabChange('disseminateRadio',e)}" -->
            <el-radio-group v-model="disseminateRadio" size="small" >
              <el-radio-button label="day" name="day">分日数据</el-radio-button>
              <el-radio-button label="hour" name="hour" >分时数据</el-radio-button>
              <el-radio-button label="action" name="action" >累积数据</el-radio-button>
            </el-radio-group>
          </div>
          <div class="disseminate_mid">
            <div class="disseminate_mid_item"><div class="disseminate_mid_title">总播放量</div><div class="disseminate_count">{{fmt(spreadInfo.total_metric.play, {micrometer: true})}}</div></div>
            <div class="disseminate_mid_item"><div class="disseminate_mid_title">自然播放量</div><div class="disseminate_count">{{fmt(spreadInfo.total_metric.natural_vv, {micrometer: true}) || '-'}}</div></div>
            <div class="disseminate_mid_item"><div class="disseminate_mid_title">自然播放率</div><div class="disseminate_count">{{fmtNaturalPlayRate}}</div></div>
            <div class="disseminate_mid_item"><div class="disseminate_mid_title">评论量</div><div class="disseminate_count">{{fmt(spreadInfo.total_metric.comment, {micrometer: true})}}</div></div>
            <div class="disseminate_mid_item"><div class="disseminate_mid_title">点赞量</div><div class="disseminate_count">{{fmt(spreadInfo.total_metric.like, {micrometer: true})}}</div></div>
            <div class="disseminate_mid_item"><div class="disseminate_mid_title">分享量</div><div class="disseminate_count">{{fmt(spreadInfo.total_metric.share, {micrometer: true})}}</div></div>
          </div>
          <div class="content_box">
            <div class="disseminate_content_top">
              <!-- @change="e=>{tabChange('disseminateContent',e)}" -->
              <el-radio-group class="tab clear" v-model="disseminateContent"  size="small">
              <el-radio-button label="play">播放量</el-radio-button>
              <el-radio-button label="like">点赞量</el-radio-button>
              <el-radio-button label="comment">评论量</el-radio-button>
              <el-radio-button label="share">分享量</el-radio-button>
              </el-radio-group>
              <div class="block">
                <el-date-picker
                  v-model="disseminateTime"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div class="bar_box">
              <Bar :info="disseminateBar" isDisposeData></Bar>
            </div>

          </div>

        </div>
        <div class="touchReach_content">
          <div class="title_box">
            <span class="title">触达频次</span>
            <el-dropdown trigger="click" @command="touchReachClick">
            <span class="el-dropdown-link">
              {{ "发布后"+touchReachDay+"天" }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="3">发布后3天</el-dropdown-item>
              <el-dropdown-item command="7">发布后7天</el-dropdown-item>
              <el-dropdown-item command="14">发布后14天</el-dropdown-item>
              <el-dropdown-item command="30">发布后30天</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </div>
          <div class="touchReach_content_box">
            <div class="touchReach_pie">
             <Pie :info="touchReachPie"></Pie>
            </div>
            <div class="list_box">
              <div class="list_head">
                <span style="width:100px">频次</span><span style="width:100px">占比</span><span style="width:100px">曝光人数</span>
              </div>
              <div class="list_content">
               <div class="list_item" v-for="(item,index) in touchReachList" :key="index">
                <span style="width:100px" class="fist_block">
                  <span class="Block" :class="'color'+index"></span>
                  <span class="fist_text">{{ item.frequency }}</span>
                </span>
                <span style="width:100px">{{ item.Proportion }}</span>
                <span style="width:100px">{{ fmt(item.exposure, {micrometer: true})}}</span>
               </div>
              </div>
            </div>
          </div>
        </div>
        <div class="costPerformance">
          <div class="left_content">
            <div class="title_box">
              <span class="title">触达性价比</span>
            </div>
            <div class="disseminate_mid costPerformance_mid">
              <div class="costPerformance_mid_item"><div class="disseminate_mid_title">千次播放成本</div><div class="disseminate_count">{{ fmt(baseInfo.basicInfo?.cpm, {micrometer: true})||'-' }}</div><div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.cpm_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div></div>
              <div class="costPerformance_mid_item"><div class="disseminate_mid_title">互动成本</div><div class="disseminate_count">{{ fmt(baseInfo.basicInfo?.cpe, {micrometer: true})||'-' }}</div><div class="scale">低于<span class="rate">{{fmt(baseInfo.basicInfo?.cpe_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div></div>
            </div>
            <div class="content_box">
            <div class="disseminate_content_top">
              <!-- @change="e=>{tabChange('costPerformanceContent',e)}" -->
              <el-radio-group class="tab clear" v-model="costPerformanceContent"  size="small">
                <el-radio-button label="cpm_daily">千次播放成本</el-radio-button>
                <el-radio-button label="cpe_daily">互动成本</el-radio-button>
              </el-radio-group>
              <div class="block">
                <el-date-picker
                  v-model="costPerformanceTime"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div class="costPerformance_bar">
              <Bar :info="costPerformanceBar" isDisposeData></Bar>
            </div>
            </div>
          </div>
          <div class="right_content">
            <div class="title_box">
              <span class="title">内容表现</span>
            </div>
            <div class="disseminate_mid costPerformance_mid">
              <div class="costPerformance_mid_item"><div class="disseminate_mid_title">完播率</div><div class="disseminate_count">{{fmt(viewerData.finish_rate/100, {micrometer: true})||'-'}}%</div><div class="scale">低于<span class="rate">{{fmt(viewerData.finish_rate_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div></div>
              <div class="costPerformance_mid_item"><div class="disseminate_mid_title">互动率</div><div class="disseminate_count">{{fmt(viewerData.interact_rate/100, {micrometer: true})||'-'}}%</div><div class="scale">低于<span class="rate">{{fmt(viewerData.interact_rate_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div></div>
              <div class="costPerformance_mid_item"><div class="disseminate_mid_title">平均播放时长</div><div class="disseminate_count">{{viewerData.avg_play_time}}s</div><div class="scale">低于<span class="rate">{{fmt(viewerData.avg_play_time_rank/100, {micrometer: true})||'-'}}%</span>同行订单</div></div>
            </div>
            <div class="content_box">
              <div class="viewers_bar">
                <Bar :info="viewersBar" isDisposeData></Bar>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="disseminate" id="recommend">
        <div class="title">种草表现</div>
        <div class="infoText">基于视频观众的搜索、评论等数据，评估视频的种草效果│更新时间：{{searchData?.modify_time}}</div>
        <div class="touchReach_content">
          <div class="title_box">
            <span class="title">搜索指数</span>
            <el-date-picker
              v-model="searchTime"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="sub_title">视频内容带动了观众的品牌搜索行为，发布后7天（含当天）品牌搜索指数均值环比增加<span class="rate">{{searchData.growth_rate/100||'-'}}%</span></div>
          <div class="brand">品牌：{{searchData.search_indexs[0].brand_name}}</div>
          <div class="search_bar" style="margin-top:10px">
            <Bar :info="searchBar" isDisposeData></Bar>
          </div>
        </div>
        <div class="brand_image_content">
          <div class="title_box">
            <span class="title">品牌形象</span>
          </div>
          <div class="image_content">
            <div class="left_content" style="border:none">
              <div class="title_box">
                <span class="subTitle">评价舆情</span>
              </div>
              <div class="popularFeelingPie">
                <Pie :info="popularFeelingPie"></Pie>
              </div>
              <div class="title_box">
                <span class="subTitle" style="margin-bottom:10px;margin-top: 60px;">分类热评词</span>
              </div>
              <!-- @change="e=>{tabChange('hotWords',e)}" -->
              <el-radio-group class="tab clear" v-model="hotWords"  size="small">
                  <el-radio-button label="0">全部</el-radio-button>
                  <el-radio-button label="1">品牌</el-radio-button>
                  <el-radio-button label="2">产品</el-radio-button>
                  <el-radio-button label="3">角色</el-radio-button>
                  <el-radio-button label="4">场景和卖点</el-radio-button>
              </el-radio-group>
              <div class="wordCloud">
                <WordCloud :info="wordCloud"></WordCloud>
              </div>
            </div>
            <div class="right_content" style="border:none">
              <div class="title_box">
                <span class="subTitle">评价内容</span>
              </div>
              <div class="title_box">
                <div class="subTitle">共{{fmt(commentCount, {micrometer: true})}}条评论</div>
              </div>
              <el-input
                style="margin-top: 10px;"
                placeholder="请输入你要搜索的评论"
                suffix-icon="el-icon-search"
                v-model="appraiseSearch"
                @change="getCommentList"
                >
              </el-input>
              <div class="appraise_list">
                <div class="appraise_item" v-for="(item,index) in commentList" :key="index">
                  <div class="appraise_left">
                    <img class="appraise_image" :src=" item.avatar_uri " alt="">
                    <div class="midbox">
                      <div><span class="appraise_nick">{{ item.nick_name }}</span><span class="appraise_time">{{item.comment_time}}2个小时前</span></div>
                      <div class="appraise_content">{{ item.comment_text }}</div>
                    </div>
                  </div>
                  <div class="appraise_rigth">
                      <span class="heart"></span>
                      <span class="heart_num">{{ fmt(item.digg_cnt, {micrometer: true}) }}</span>
                    </div>
                </div>

              </div>
            </div>
            </div>
        </div>
      </div>
      <div class="disseminate" id="transform">
        <div class="title">转化表现</div>
        <div class="infoText">基于转化量、GMV等数据。评估视频的转化效果|更新时间：{{ baseInfo?.modify_time }}</div>
        <div class="transform_content">
          <div class="title_box">
            <span class="title">直接转化漏斗</span>
          </div>
          <div class="sub_title">APP安装完成成本
            <el-tooltip  effect="dark" content="任务金额/APP安装完成量(仅安包):APP安装完成量为0时，CPA设定为0" placement="top-start">
                  <i class="el-icon-question" style="margin-left:4px"></i>
            </el-tooltip><span class="rate">￥{{fmt(baseInfo.basicInfo.cpa, {micrometer: true})||'-'}}</span></div>
          <div class="transform_box">
            <div class="display_volume">
              <div class="blue_block first_block">
                <span>组件展现量</span>
              </div>
              <div class="transform_count_box">
                <div class="transform_count">{{fmt(baseInfo.show, {micrometer: true})||'-'}}</div>
                <div class="sub_title">超过同行业<span class="rate">{{!baseInfo.show?'-':fmt(baseInfo.show_rank/100, {micrometer: true})||'-'}}%</span>的订单</div>
              </div>
            </div>
            <div class="display_volume">
              <div class="blue_block second_block">
                <span>组件点击量</span>
              </div>
              <div class="transform_count_box">
                <div class="transform_count">{{fmt(baseInfo.click, {micrometer: true})||'-'}}</div>
                <div class="sub_title">超过同行业<span class="rate">{{!baseInfo.click?'-':fmt(baseInfo.click_rank/100, {micrometer: true})||'-'}}%</span>的订单</div>
              </div>
            </div>
            <div class="display_volume">
              <div class="blue_block third_block">
                <span>APP安装完成率(仅安卓)</span>
              </div>
              <div class="transform_count_box">
                <div class="transform_count">{{fmt(baseInfo.convert, {micrometer: true})||'-'}}</div>
                <div class="sub_title">超过同行业<span class="rate">{{!baseInfo.convert?'-':fmt(baseInfo.convert_rank/100, {micrometer: true})||'-'}}%</span>的订单</div>
              </div>
            </div>
            <div class="solid1"></div>
            <div class="solid2"></div>
            <div class="solid3"></div>
            <div class="CTR_block">
              <div class="sub_title">点击率（CTR）</div>
              <div class="CTR_rate">{{fmt(baseInfo.ctr/100, {micrometer: true})||'-'}}%</div>
              <div class="sub_title">超过同行业<span class="rate">{{!baseInfo.ctr?'-':fmt(baseInfo.ctr_rank/100, {micrometer: true})||'-'}}%</span>的订单</div>
            </div>
            <div class="CVR_block">
              <div class="sub_title">转化率（CVR）</div>
              <div class="CTR_rate">{{fmt(baseInfo.cvr/100, {micrometer: true})||'-'}}%</div>
              <div class="sub_title">超过同行业<span class="rate">{{!baseInfo.cvr?'-':fmt(baseInfo.cvr_rank/100, {micrometer: true})||'-'}}%</span>的订单</div>
            </div>
            <div class="PVR_block">
              <div class="sub_title">展现转化率（PVR）</div>
              <div class="CTR_rate">{{fmt(baseInfo.pvr/100, {micrometer: true})||'-'}}%</div>
              <div class="sub_title">超过同行业<span class="rate">{{!baseInfo.pvr?'-':fmt(baseInfo.pvr_rank/100, {micrometer: true})||'-'}}%</span>的订单</div>
            </div>
          </div>
        </div>
      </div>
      <!-- v-if="item_5a_data==0" -->
      <div class="disseminate" id="crowd" v-if="showfiveA">
        <div class="title">人群资产</div>
        <div class="infoText">通过达人营销产生的人群资产沉淀|更新时间：{{ spectatorData?.modify_time }}</div>
        <div class="transform_content">
          <div class="title_box">
            <span class="title">观众中5A关系人群分布</span>
            <el-dropdown trigger="click" @command="agentClick">
            <span class="el-dropdown-link">
              {{ "发布后"+agentDay+"天" }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="3">发布后3天</el-dropdown-item>
              <el-dropdown-item command="7">发布后7天</el-dropdown-item>
              <el-dropdown-item command="14">发布后14天</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </div>
          <div class="sub_title">对比投放前，视频观众中间询（Ask，A3）人群量 {{spectatorData.item_5a_data.over_percent.a3_over>0?'增加':'减少'}}{{fmt(spectatorData.item_5a_data.over_percent.a3_over/100, {micrometer: true})||''}}%，其中主动问询（Ask，A3）人群 {{spectatorData.item_5a_data.over_percent.a3_initiative_over>0?'增加':'减少'}}{{fmt(spectatorData.item_5a_data.over_percent.a3_initiative_over/100, {micrometer: true})||''}}%<i class="el-icon-sort" style="color:#FF5C00;transform: rotate(90deg);"></i><span class="rate" @click="askClick">{{ask?'查看主动':'返回查看'}}问询(Ask，A3)</span></div>
          <div class="spectator_box">
            <Bar :info = "spectatorBar" isDisposeData></Bar>
            <div class="spectator_brand">品牌：{{ spectatorData.brand_name }}</div>
          </div>
        </div>
      </div>
      <div class="disseminate" id="spectator">
        <div class="f-c-b">
          <div>
            <div class="title">观众画像</div>
            <div class="infoText">通过达人营销产生的人群资产沉淀|更新时间：{{audienceData?.modify_time}}</div>
          </div>
          <!-- @change="e=>{tabChange('audiencePortraitRadio',e)}" -->
          <el-radio-group v-model="audiencePortraitRadio" size="small" >
            <el-radio-button label="1">播放</el-radio-button>
            <el-radio-button label="3">点赞</el-radio-button>
            <el-radio-button label="4">评论</el-radio-button>
            <el-radio-button label="2">分享</el-radio-button>
            <el-radio-button label="5">组件点击</el-radio-button>
          </el-radio-group>
        </div>
        <div class="image_content">
          <div class="left_content">
            <div class="title_box">
              <span class="title">用户地域</span>
            </div>
            <div class="part5Chart1Container">
              <ChinaChart1 :chinaChartInfo="chinaChartInfo1" ref="detailPart5Chart1"></ChinaChart1>
            </div>

          </div>
          <div class="right_content">
            <div class="title_box f-c-b">
              <span class="title">地域占比</span>
              <!-- @change="e=>{tabChange('areaRadio',e)}" -->
              <el-radio-group v-model="areaRadio" size="small">
                <el-radio-button label="province_distribution" content="">省份</el-radio-button>
                <el-radio-button label="city_distribution" content="">城市</el-radio-button>
              </el-radio-group>
            </div>
            <div class="sub_title">分布最多的3个{{areaRadio=='province_distribution'?'省份':'城市'}}为{{ regionData[0].key||''}}、{{regionData[1].key||''}}、{{ regionData[2].key||''}}</div>
            <div class="region_proportion_box">
              <div class="region_proportion_item" v-for="(item,index) in regionData" :key="index">
                <span class="region_proportion_text">{{ item.key }}</span>
                <div class="proportion_box">
                  <span class="proportion_content" :style="{width:item.width}"></span>
                  <span class="proportion_text" :style="{left:item.width}">{{item.value}}{{item.value?'%':''}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="image_content">
          <div class="left_content">
            <div class="title_box">
            <span class="title">性别分布</span>
            </div>
            <div class="sub_title">{{genderData[0].key=='male'?'男性':'女性'||''}}用户居多，占比{{genderData[0].value? genderData[0].value:0}}%</div>
            <div class="genderPie">
                <Pie :info="genderPie"></Pie>
              </div>
          </div>
          <div class="right_content">
            <div class="title_box f-c-b">
              <span class="title">年龄占比</span>
            </div>
            <div class="sub_title">{{ ageBar.xAxis[0] }}用户居多，占比{{ ageBar.data[0].data[0] }}%</div>
            <div class="ageBar">
            <Bar :info = "ageBar" isDisposeData></Bar>
          </div>
          </div>
        </div>
        <div class="image_content">
          <div class="left_content">
            <div class="title_box">
            <span class="title">活跃度分布</span>
            </div>
            <div class="sub_title">观看视频用户的抖音活跃度较好，{{activityData[0].key||''+'活跃'}}用户占比{{activityData[0].value||0}}%</div>
            <div class="genderPie">
              <Pie :info="activityPie"></Pie>
            </div>
          </div>
          <div class="right_content">
            <div class="title_box f-c-b">
              <span class="title">设备分布</span>
            </div>
            <div class="sub_title">{{deviceData[0].key||''}}手机用户占比{{deviceData[0].value||0}}，消费能力好</div>
            <div class="genderPie">
              <Pie :info="equipmentPie"></Pie>
            </div>
          </div>
        </div>
        <div class="transform_content">
            <div class="title_box">
            <span class="title">兴趣分布</span>
            </div>
            <div class="sub_title">视频受众最感兴趣的三种内容类型<span class="rate">{{interestBar.xAxis[0]}}、{{interestBar.xAxis[1]}}、{{interestBar.xAxis[2]}}</span></div>
            <div class="interestBar">
              <Bar :info = "interestBar" isDisposeData></Bar>
            </div>
        </div>
      </div>

    </div>
  </div>
  </div>

</template>

<script>
import contenr from "../content"
import ChinaChart1 from "../../components/Echart/ChinaChart1.vue";
import tools from "../../components/tools/tools.js";
import Radar from "../../components/newEchart/Radar.vue";
import Bar from "../../components/newEchart/Bar.vue";
import Pie from "../../components/newEchart/Pie.vue";
import WordCloud from "../../components/newEchart/WordCloud.vue";


export default {
  name: "Detail",
  props:[],
  components:{
    contenr,
    ChinaChart1,
    Radar,
    Bar,
    Pie,
    WordCloud,
  },
  data(){
    return {
      infoTitle:'APP安装完成成本',
      setTop:false,
      origid:this.$route.query.origid,
      audienceData:{},
      ask:true,
      interestData:{},
      deviceData:{},
      activityData:{},
      genderData:{},
      commentCount:0,
      commentList:[],
      searchData:{},
      viewerData:{},
      touchReachDay:"3",
      agentDay :"3",
      spreadInfo:{},
      spread_percentage:0,
      seed_percentage:0,
      convert_percentage:0,
      measurement_info:{},
      create_timestamp:'',
      baseInfo:{},
      cooperate:{},
      vid:'',
      accountnumberId:'',
      plattaskid:'',
      leftPartIndex:0,
      activityPie:{},
      equipmentPie:{},
      interestBar:{},
      ageBar:{},
      genderPie:{},
      regionData:[],
      areaRadio:'province_distribution',
      audiencePortraitRadio:'1',
      spectatorBar:{},
      appraiseSearch:'',
      hotWords:'0',
      wordCloud: {},
      popularFeelingPie:{},
      searchBar:{},
      searchTime:[],
      viewersBar:{},
      costPerformanceBar:{},
      costPerformanceContent:'cpm_daily',
      touchReachList:[],
      touchReachPie:{},
      disseminateBar:{},
      disseminateTime:[],
      costPerformanceTime:[],
      disseminateRadio:'day',
      disseminateContent:'play',
      synthesizeRadar:{},
      leftPartArr:[
        {name:"合作评价",href:'cooperate'},
        {name:"综合表现",href:'synthesize'},
        {name:"传播表现",href:'disseminate'},
        {name:"种草表现",href:'recommend'},
        {name:"转化表现",href:'transform'},
        {name:"人群资产",href:'crowd', hide:false},
        {name:"观众画像",href:'spectator'},
      ],
      chinaChartInfo1:{
        nodeId:'detailPart5Echart1',//节点
        data:[]
      },
      showfiveA:false,
    }
  },
  computed:{
    fmtNaturalPlayRate() {
      if(!this.spreadInfo.total_metric.natural_vv) return '-'
      let rate = (this.spreadInfo.total_metric.natural_vv / this.spreadInfo.total_metric.play) * 100
      return `${(rate || 0).toFixed(2)}%`
    }
  },
  watch:{
    disseminateRadio(){
      this.getSpread()
    },
    disseminateTime(){
      this.getSpread()
    },
    disseminateContent(){
      this.getSpread()
    },
    touchReachDay(){
      this.getTouchReach()
    },
    agentDay(){
      this.getSpectatorBar()
    },
    costPerformanceTime(){
      this.getCostPerformance()
    },
    costPerformanceContent(){
      this.getCostPerformance()
    },
    searchTime(){
      this.getSearchBar()
    },
    hotWords(){
      this.getWordCloud()
    },
    audiencePortraitRadio(){
      this.getAudiencePortrait()
    },
    areaRadio(){
      this.getAudiencePortrait()
    }
  },
  created(){
    this.getCrmInfo()
    this.orderID = this.$route.query.id

  },
  methods:{
    infoChange(value){
      this.infoTitle = value
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 100){
        this.setTop = true
      }else{
        this.setTop = false
      }
    },
    handleErr(res){
     if(res.data.code !== 0){
      this.$message({
            message: res.data.error||'请稍后刷新重试',
            type: 'error'
          });
     }
    },
    getBaseInfo(){
      let url =`agent-convert?starid=${this.accountnumberId}&itemid=${this.vid}&order_id=${this.plattaskid}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-convert?starid=1721629055329287&itemid=7057812621868698891`
      // }
      this.$axios.get(url).then(res => {
        if(res.data.code!==0){
          this.handleErr(res)
          return
        }
        let data = res?.data?.data
        this.baseInfo = data
        this.measurement_info = data?.basicInfo?.measurement_info ||{}
        // if(data?.basicInfo?.order_info[0]?.item_info?.create_timestamp){
        //   this.create_timestamp = this.unixTime(data?.basicInfo?.order_info[0]?.item_info?.create_timestamp)
        // }
        if(this.measurement_info){
          this.synthesizeRadar = {
            name: '',
            data: [
                {
                    value: [],
                    name: '综合表现',
                },
            ],
            indicator: [
                {
                    name: '传播表现',
                    max: 100,
                    min:0,
                },
                {
                    name: '种草表现',
                    max: 100,
                    min: 0,
                },
                {
                    name: '转化表现',
                    max: 100,
                    min: 0,
                },
                ]
            }
            this.synthesizeRadar.data = this.synthesizeRadar.data.map(x=>{
                x.value.push(this.measurement_info.spread_score)
                x.value.push(this.measurement_info.seed_score)
                x.value.push(this.measurement_info.convert_score)
                return x
            })
            this.spread_percentage = (this.measurement_info.spread_score/this.maxScore(this.measurement_info.spread_interval))*100
            this.seed_percentage = (this.measurement_info.seed_score/this.maxScore(this.measurement_info.seed_interval))*100
            this.convert_percentage = (this.measurement_info.convert_score/this.maxScore(this.measurement_info.convert_interval))*100
          }
          if(this.baseInfo?.basicInfo?.modify_time){
            this.baseInfo.basicInfo.modify_time = this.unixTime(this.baseInfo?.basicInfo?.modify_time,'YYYY-MM-DD HH:mm:ss')
          }
          if(this.baseInfo?.modify_time){
            this.baseInfo.modify_time = this.unixTime(this.baseInfo?.modify_time,'YYYY-MM-DD HH:mm:ss')
          }

      }).finally(() => {
      })
    },
    unixTime(time, formatStr='YYYY-MM-DD'){
      return this.dayjs.unix(time).format(formatStr)||'-'
    },
    maxScore(arr){
      if(!arr){
        return
      }else{
        let score = arr[3].split('-')[1]
        return score
      }

    },
    numChange(num){
      if(!num){
        return
      }
      if(num == "1"){
        return '不满意'
      }else if(num == "2"){
        return '需关注'
      }else if(num == "3"){
        return '很满意'
      }
    },
    getCrmInfo(){
      this.$axios.get(`api.php?m=index|api|gx&a=cooperationDetail&type=1&origid=${this.origid}`).then(res => {
        this.cooperate = res
        this.cooperate.effect = this.numChange(res.effect)
        this.cooperate.quality = this.numChange(res.quality)
        this.cooperate.experience = this.numChange(res.experience)
        this.accountnumberId = res.accountnumbername
        this.plattaskid = res.plattaskid
        this.vid = res.vid
        this.disseminateTime[0] = this.dayjs(this.cooperate.release_at).format('YYYY-MM-DD')
        this.disseminateTime[1] = this.dayjs(this.cooperate.release_at).add(30, 'day').format('YYYY-MM-DD')
        this.costPerformanceTime[0] = this.dayjs(this.cooperate.release_at).format('YYYY-MM-DD')
        this.costPerformanceTime[1] = this.dayjs(this.cooperate.release_at).add(30, 'day').format('YYYY-MM-DD')
        this.searchTime[0] = this.dayjs(this.cooperate.release_at).format('YYYY-MM-DD')
        this.searchTime[1] = this.dayjs(this.cooperate.release_at).add(30, 'day').format('YYYY-MM-DD')
        this.getBaseInfo()
        this.getSpread()
        this.getTouchReach()
        this.getCostPerformance()
        this.getViewersBar()
        this.getSearchBar()
        this.getPopularFeeling()
        this.getWordCloud()
        this.getCommentList()
        this.getAudiencePortrait()
        this.getSpectatorBar()
      }).finally(() => {
      })
    },
    leftPart(href,index){
      const anchor = document.getElementById(href);
	    anchor.scrollIntoView();
      this.leftPartIndex = index
    },
    tabChange(key,val){
      this[key] = val
    },
    getSpread(){
      let start_time =""
      let end_time =""
      if(this.disseminateTime){
        start_time = this.disseminateTime[0]? this.dayjs(this.disseminateTime[0]).format('YYYYMMDD'): ''
        end_time = this.disseminateTime[1]? this.dayjs(this.disseminateTime[1]).format('YYYYMMDD'):''
      }
      let url =`agent-item-spread?starid=${this.accountnumberId}&itemid=${this.vid}&statics_type=${this.disseminateRadio}&start_time=${start_time}&end_time=${end_time}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-item-spread?itemid=7148351232954961188&starid=1639751596341256&statics_type=${this.disseminateRadio}&start_time=${start_time}&end_time=${end_time}`
      // }
      this.$axios.get(url).then(res => {
      // this.$axios.get(`agent-item-spread?itemid=7148351232954961188&starid=1639751596341256&statics_type=${this.disseminateRadio}&start_time=${start_time}&end_time=${end_time}`).then(res => {
        if(res.data.code!==0){
          this.handleErr(res)
          return
        }
        this.spreadInfo = res.data.data
        this.disseminateBar = {
        xAxis: [],
        data: [
          {
            stack: '播放量',
            color: '#3F90FD',
            barWidth: 40,
            name: '播放量',
            data: [],
            type: 'line',
            symbol: 'none',
            areaStyle: {
              color: {
                 type: 'linear',
                 x: 0,
                 y: -0.2,
                 x2: 0,
                 y2: 1,
                 colorStops: [
                    {
                       offset: 0,
                       color: 'RGBA(63, 144, 253, 0.1)'
                    },
                    {
                       offset: 1,
                       color: '#fff'
                    }
                 ]
              }
            }
          },
        ],
      }
      if(this.spreadInfo?.modify_time){
          this.spreadInfo.modify_time = this.unixTime(this.spreadInfo?.modify_time,'YYYY-MM-DD HH:mm:ss')
        }
      let item_stat =this._.cloneDeep(res?.data?.data?.item_stat || [])
      this.disseminateBar.xAxis = item_stat?.map(x=>x.date).splice(0,9)
      this.disseminateBar.data[0].data = item_stat.map(x=>Number(x[this.disseminateContent])).splice(0,9)
      }).finally(() => {
      })
    },
    touchReachClick(val){
      this.touchReachDay = val
    },
    agentClick(val){
      this.agentDay = val
    },
    askClick(){
      this.ask = !this.ask
      this.getSpectatorBar()
    },
    getTouchReach(){
      let url =`agent-item-frequency?starid=${this.accountnumberId}&itemid=${this.vid}&day=${this.touchReachDay}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-item-frequency?itemid=7148351232954961188&starid=1639751596341256&day=${this.touchReachDay}`
      // }
    this.$axios.get(url).then(res => {
    // this.$axios.get(`agent-item-frequency?itemid=7148351232954961188&starid=1639751596341256&day=${this.touchReachDay}`).then(res => {
      if(res.data.code!==0){
        this.handleErr(res)
        return
        }
      let data = res.data.data
      this.touchReachPie = {
        name: '触达频次',
        radius: ['50%', '70%'], // 格式：['40%', '70%']
        showLabel: false,  // 默认为true
        showPercent: false,
        showLabelRate: 5, //比率大于百分之5的时候展示label
        data: [
          // 数据配置同官方文档（https://echarts.apache.org/zh/option.html#series-pie.data）
          // 添加了color属性和showLabel属性
          // color决定对应部分的图形颜色、label颜色和labelLine的颜色
          { value: 0, name: '触达1次', color: '#1C7CFC'},
          { value: 0, name: '触达2次', color: '#3E92FF'},
          { value: 0, name: '触达3次', color: '#42A6FE'},
          { value: 0, name: '触达4次', color: '#73C2FF'},
          { value: 0, name: '触达5次', color: '#88CBFF'},
          { value: 0, name: '触达6次', color: '#ABD8FF'},
          { value: 0, name: '触达7次及以上', color: '#DBF0FF'},

        ],
        custom: {
                title: {
                  text: "总人数",
                  subtext:"" ,
                  textAlign: "center",
                  x: "49%",
                  y: "45%",
                },
                legend: false,
              }
        }
        this.touchReachPie.data.map((x,i)=>{
          x.value = Number(data.frequency[`eq_${i+1}`])
        })
        this.touchReachPie.custom.title.subtext = data.total_frequency_cnt
        this.touchReachList=[
        {frequency:'触达1次',Proportion:'',exposure:''},
        {frequency:'触达2次',Proportion:'',exposure:''},
        {frequency:'触达3次',Proportion:'',exposure:''},
        {frequency:'触达4次',Proportion:'',exposure:''},
        {frequency:'触达5次',Proportion:'',exposure:''},
        {frequency:'触达6次',Proportion:'',exposure:''},
        {frequency:'触达7次及以上',Proportion:'',exposure:''},
      ]
       this.touchReachList.forEach((x,i)=>{
        if(i==6){
          x.Proportion = Number((data.frequency[`gt_${i+1}`]/data.total_frequency_cnt)*100).toFixed(2)+'%'
          x.exposure = data.frequency[`gt_${i+1}`]
        }else{
          x.Proportion = Number((data.frequency[`eq_${i+1}`]/data.total_frequency_cnt)*100).toFixed(2)+'%'
          x.exposure = data.frequency[`eq_${i+1}`]
        }

       })
        }).finally(() => {
        })
    },
    changeTime(time){
      if(typeof(time)!=="string"){
        time = time.toString()
      }
      let month = time.substr(4, 2);
      let day = time.substr(6, 2);
      let formattedDate = `${month}-${day}`;
      return formattedDate
    },
    getCostPerformance(){
      let start_time =""
      let end_time =""
      if(this.costPerformanceTime){
        start_time = this.costPerformanceTime[0]? this.dayjs(this.costPerformanceTime[0]).format('YYYYMMDD'): ''
        end_time = this.costPerformanceTime[1]? this.dayjs(this.costPerformanceTime[1]).format('YYYYMMDD'):''
      }
      let url =`agent-order-reach?starid=${this.accountnumberId}&itemid=${this.vid}&start_time=${start_time}&end_time=${end_time}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-order-reach?itemid=7148351232954961188&starid=1639751596341256&start_time=20230320&end_time=20230406`
      // }
      this.$axios.get(url).then(res => {
      // this.$axios.get(`agent-order-reach?itemid=7148351232954961188&starid=1639751596341256&start_time=20230320&end_time=20230406`).then(res => {
        if(res.data.code!==0){
          this.handleErr(res)
          return
        }
        this.costPerformanceBar = {
          xAxis: [''],
          data: [
          {
            stack: '播放量',
            color: '#3F90FD',
            barWidth: 40,
            name: '播放量',
            data: [],
            type: 'line',
            symbol: 'none',
            areaStyle: {
              color: {
                 type: 'linear',
                 x: 0,
                 y: -0.2,
                 x2: 0,
                 y2: 1,
                 colorStops: [
                    {
                       offset: 0,
                       color: 'RGBA(63, 144, 253, 0.1)'
                    },
                    {
                       offset: 1,
                       color: '#fff'
                    }
                 ]
              }
            }
          },
          ],
      }
      let barData =this._.cloneDeep(res?.data?.data[this.costPerformanceContent]|| [])
      this.costPerformanceBar.xAxis = barData?.map(x=>{
                  if(x.visit_date){
                    x.visit_date = this.changeTime(x.visit_date)
                  }
                  return x.visit_date
                }).splice(0,9)
      this.costPerformanceBar.data[0].data = barData.map(x=>Number(x.value)).splice(0,9)
      }).finally(() => {
      })
    },

    getViewersBar(){
      let url =`agent-content-per?starid=${this.accountnumberId}&itemid=${this.vid}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-content-per?itemid=7148351232954961188&starid=1639751596341256`
      // }
      this.$axios.get(url).then(res => {
        // this.$axios.get(`agent-content-per?itemid=7148351232954961188&starid=1639751596341256`).then(res => {
          if(res.data.code!==0){
            this.handleErr(res)
            return
        }
          this.viewerData = res.data.data
          if(res?.data?.data?.watch_distribution){
              let watch_distribution = JSON.parse(res?.data?.data?.watch_distribution)||{}
              this.viewersBar = {
                xAxis:[],
                data: [
                  {
                    stack: '观看人数百分比',
                    color: '#3F90FD',
                    barWidth: 40,
                    name: '观看人数百分比',
                    data: [],
                    type: 'line',
                    symbol: 'none',
                    areaStyle: {
                      color: {
                         type: 'linear',
                         x: 0,
                         y: -0.2,
                         x2: 0,
                         y2: 1,
                         colorStops: [
                            {
                               offset: 0,
                               color: 'RGBA(63, 144, 253, 0.1)'
                            },
                            {
                               offset: 1,
                               color: '#fff'
                            }
                         ]
                      }
                    },
                  },
                ],
                custom: {
                  dataZoom: [
                    {
                    type: "inside",
                    formattershow:true,
                    start: 0,
                    end: 10,
                  },
                  {
                    show: true,
                    type: "slider",
                    top: "90%",
                    start: 0,
                    end: 10
                  }],
                  xAxis: {
                    axisLabel: {
                      interval: "auto",
                      formatter:'{value}s'
                    },
                  },
                  yAxis:{
                    name:'观看人数百分比',
                    axisLabel:{
                      formatter:'{value}%'
                    }
                  }
                }
              }
              this.viewersBar.xAxis = Object.keys(watch_distribution)
              if(watch_distribution){
               let arr = Object.values(watch_distribution)
               let sum = 0
               arr.forEach(item=>{
                sum+=item
               })

                this.viewersBar.data[0].data = arr.map(x=>{return (x/sum*100).toFixed(2)})

              }

            }

      }).finally(() => {
      })
    },
    getSearchBar(){
      let start_time =""
      let end_time =""
      if(this.searchTime){
        start_time = this.searchTime[0]? this.dayjs(this.searchTime[0]).format('YYYYMMDD'): ''
        end_time = this.searchTime[1]? this.dayjs(this.searchTime[1]).format('YYYYMMDD'):''
      }
      let url =`agent-search-index?starid=${this.accountnumberId}&itemid=${this.vid}&start_time=${start_time}&end_time=${end_time}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-search-index?itemid=7206290240045124902&starid=1639751596341256&start_time=${start_time}&end_time=${end_time}`
      // }
      this.$axios.get(url).then(res => {
      // this.$axios.get(`agent-search-index?itemid=7206290240045124902&starid=1639751596341256&start_time=${start_time}&end_time=${end_time}`).then(res => {
            if(res.data.code!==0){
              this.handleErr(res)
              return
            }
            this.searchData = res.data.data
            if(res.data.nowTime){
              this.searchData.modify_time = this.unixTime(res.data.nowTime,'YYYY-MM-DD HH:mm:ss')
            }
            if(res?.data?.data?.search_indexs[0]?.search_index){
              this.searchBar = {
                xAxis: [],
                  data: [
                    {
                      stack: '搜索指数',
                      color: '#3F90FD',
                      barWidth: 40,
                      name: '搜索指数',
                      data: [],
                      type: 'line',
                      symbol: 'none',
                      areaStyle: {
                        color: {
                           type: 'linear',
                           x: 0,
                           y: -0.2,
                           x2: 0,
                           y2: 1,
                           colorStops: [
                              {
                                 offset: 0,
                                 color: 'RGBA(63, 144, 253, 0.1)'
                              },
                              {
                                 offset: 1,
                                 color: '#fff'
                              }
                           ]
                        }
                      },
                    },
                  ],
                  custom:{
                    xAxis: {
                    axisLabel: {
                      interval: "auto",
                    }
                    },
                    yAxis:{
                      name:"播放量"
                    }
                  }
                }
              let search_index = res?.data?.data?.search_indexs[0]?.search_index

              if(search_index){
                this.searchBar.xAxis = search_index?.map(x=>{
                  if(x.visit_date){
                    x.visit_date = this.changeTime(x.visit_date)
                  }
                  return x.visit_date
                })
                this.searchBar.data[0].data = search_index.map(x=>Number(x.value))
              }

            }
      }).finally(() => {
      })
      },
    getPopularFeeling(){
      let url =`agent-item-emotion?starid=${this.accountnumberId}&itemid=${this.vid}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-item-emotion?itemid=7206290240045124902&starid=1639751596341256`
      // }
      this.$axios.get(url).then(res => {
    // this.$axios.get(`agent-item-emotion?itemid=7206290240045124902&starid=1639751596341256`).then(res => {
      if(res.data.code!==0){
        this.handleErr(res)
        return
        }
      let data = res.data.data
      this.popularFeelingPie = {
        name: '评价舆情',
          radius: ['50%', '70%'], // 格式：['40%', '70%']
          showLabel: true,  // 默认为true
          showPercent: true,
          showLabelRate: 5, //比率大于百分之5的时候展示label
          data: [
            // 数据配置同官方文档（https://echarts.apache.org/zh/option.html#series-pie.data）
            // 添加了color属性和showLabel属性
            // color决定对应部分的图形颜色、label颜色和labelLine的颜色
            { value: 10, name: '正面', color: '#1C7CFC'},
            { value: 16, name: '负面', color: '#3E92FF'},
            { value: 74, name: '中立', color: '#42A6FE'},

          ],
          custom: {
                  legend: false,
                }
      }
      let arr = ['pos_cnt','neg_cnt','neu_cnt']
      let arr1 = ['pos_rate','neg_rate','neu_rate']
      this.popularFeelingPie.data.map((x,i)=>{
        x.value = Number(data.emotion_distribution[arr[i]])
      })

      }).finally(() => {
      })
    },
    getWordCloud(){
      let url =`agent-hot-comment?starid=${this.accountnumberId}&itemid=${this.vid}&keyword_type=${this.hotWords}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-hot-comment?itemid=7206290240045124902&starid=1639751596341256&keyword_type=0`
      // }
      this.$axios.get(url).then(res => {
    // this.$axios.get(`agent-hot-comment?itemid=7206290240045124902&starid=1639751596341256&keyword_type=0`).then(res => {
      if(res.data.code!==0){
        this.handleErr(res)
        return
        }
      let data = res.data.data
      this.wordCloud = {
      name: '分类热评词',
      data: [],
      }
      if(data?.keywords){
        let keys = Object.keys(data.keywords)
        let values = Object.values(data.keywords)
        let colors = ['#FF5500','#FF5C00','#FFA555','#38A1FF']
        keys.forEach((x,i)=>{
        this.wordCloud.data.push({name:keys[i],value:values[i],color:colors[i]})
      })
      }

      }).finally(() => {
      })
    },
    getCommentList(){
      let url =`agent-comment-search?starid=${this.accountnumberId}&itemid=${this.vid}&page=1&keyword=${this.appraiseSearch}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-comment-search?itemid=7206290240045124902&starid=1639751596341256&page=1`
      // }
      this.$axios.get(url).then(res => {
    // this.$axios.get(`agent-comment-search?itemid=7206290240045124902&starid=1639751596341256&page=1`).then(res => {
      if(res.data.code!==0){
          this.handleErr(res)
          return
        }
      let data = res.data.data
      this.commentList = data.comment_list
      this.commentCount = data.comment_count

      }).finally(() => {
      })
    },
    getAudiencePortrait(){
      let url =`agent-order-distri?starid=${this.accountnumberId}&itemid=${this.vid}&metric_type=${this.audiencePortraitRadio}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-order-distri?itemid=7206290240045124902&starid=1639751596341256&metric_type=${this.audiencePortraitRadio}`
      // }
      this.$axios.get(url).then(res => {
    // this.$axios.get(`agent-order-distri?itemid=7206290240045124902&starid=1639751596341256&metric_type=${this.audiencePortraitRadio}`).then(res => {
      if(res.data.code!==0){
          this.handleErr(res)
          return
        }
      if(res.data.nowTime){
        this.audienceData.modify_time = this.unixTime(res.data.nowTime,'YYYY-MM-DD HH:mm:ss')
      }
      let data = res?.data?.data?.item_user_distribution
      if(data){
        if(this.areaRadio=='city_distribution'&&data?.city_distribution){
          data.city_distribution = data.city_distribution.filter(x=>x.key!="unknown")
          data.city_distribution.sort((a,b)=>b.value - a.value)
          let chinaCitySum = 0
          data?.city_distribution?.forEach((item,i)=>{
            chinaCitySum+=item.value?Number(item.value):0
          })
          this.regionData = data[this.areaRadio].map(x=>{
            x.value = ((x.value/chinaCitySum)*100).toFixed(2)
            return x
            }).splice(0,9)
          this.regionData = this.regionData.map(x=>{
            x.width = x.value*6.7+'px'
            return x
          })
        }
        if(this.areaRadio=='province_distribution'&&data?.province_distribution){
          data.province_distribution = data.province_distribution.filter(x=>x.key!="unknown")
          data.province_distribution.sort((a,b)=>b.value - a.value)
          let chinaProvinceSum = 0
          data?.province_distribution?.forEach((item,i)=>{
          chinaProvinceSum+=item.value?Number(item.value):0
          })
          let chinaArr = []
          chinaArr = data?.province_distribution.map(x=>{
            return {name:x.key,value:((x.value/chinaProvinceSum)*100).toFixed(2)-0}
          })
          this.chinaChartInfo1.data = [...chinaArr]
          if(this.$refs.detailPart5Chart1){
            this.$refs.detailPart5Chart1.chinaChart(this.chinaChartInfo1)
          }
          console.log('this.chinaChartInfo1.data :>> ', this.chinaChartInfo1.data);
          this.regionData = data[this.areaRadio].map(x=>{
            x.value = ((x.value/chinaProvinceSum)*100).toFixed(2)
            return x
            }).splice(0,9)
          this.regionData = this.regionData.map(x=>{
            x.width = x.value*6.7+'px'
            return x
          })
        }

        if(data.gender_distribution){
          this.genderData = data.gender_distribution
          this.genderPie = {
            name: '性别分布',
            radius: ['50%', '70%'], // 格式：['40%', '70%']
            showLabel: true,  // 默认为true
            showPercent: true,
            showLabelRate: 5, //比率大于百分之5的时候展示label
            data: [],
            custom: {
                    legend: false,
                  }
          }
        }

        if(data.gender_distribution){
          let sum = 0
          data.gender_distribution.forEach(x=>{
            sum+= x.value
          if(x.key==='male'){
            x.name = '男性占比'
            x.color ='#4D93FF'
           }else{
            x.name = '女性占比'
            x.color = '#F76C42'
           }
          })
          this.genderPie.data = data.gender_distribution.map(x=>{
            x.value = ((x.value/sum)*100).toFixed(2)
            return x
          })


        }
        if(data.age_distribution){
          let sum = 0
          data.age_distribution.forEach(x=>{
            sum+= x.value
          })
          this.ageBar = {
              xAxis: [],
              data: [
                {
                  stack: '年龄占比',
                  color: '#4D93FF',
                  barWidth: 20,
                  name: '年龄占比',
                  data: [],
                  type: 'bar',
                  symbol: 'none',
                  itemStyle: {
                    borderRadius: [10, 10, 0, 0],
                  }
                },
              ],
              custom: {
                legend: false,
                yAxis:{
                    name:'百分比',
                    axisLabel:{
                      formatter:'{value}%'
                    }
                  }
              }
          }
          this.ageBar.xAxis = data.age_distribution.map(x=>x.key)
          this.ageBar.data[0].data = data.age_distribution.map(x=>((x.value/sum)*100).toFixed(2))
        }
        if(data.activity_distribution){
          this.activityData = data.activity_distribution
          this.activityPie = {
            name: '活跃度分布',
            radius: ['50%', '70%'], // 格式：['40%', '70%']
            showLabel: true,  // 默认为true
            showPercent: true,
            showLabelRate: 5, //比率大于百分之5的时候展示label
            data: [],
            custom: {
                    legend: false,
                  }
          }
          let sum = 0
          data.activity_distribution.forEach(x=>{
            sum+= x.value
            if(x.key==='重度'){
            x.name = '重度活跃'
            x.color ='#4D93FF'
           }else if(x.key==='中度'){
            x.name = '中度活跃'
            x.color = '#3FA5FD'
           }else if(x.key==='轻度'){
            x.name = '轻度活跃'
            x.color = '#88CBFF'
           }else if(x.key==='静默'){
            x.name = '静默活跃'
            x.color = '#ABD8FF'
           }
          })
          this.activityPie.data = data.activity_distribution.map(x=>{
            x.value = ((x.value/sum)*100).toFixed(2)
            return x
          })

        }
        if(data.device_distribution){
          this.deviceData = data.device_distribution
          this.equipmentPie = {
            name: '活跃度分布',
              radius: ['50%', '70%'], // 格式：['40%', '70%']
              showLabel: true,  // 默认为true
              showPercent: true,
              showLabelRate: 5, //比率大于百分之5的时候展示label
              data: [],
              custom: {
                      legend: false,
                    }
          }
          let sum = 0
          data.device_distribution.forEach(x=>{
            sum+= x.value
            if(x.key==='华为'){
            x.color ='#42A6FE'
           }else if(x.key==='vivo'){
            x.color = '#73C2FF'
           }else if(x.key==='小米'){
            x.color = '#88CBFF'
           }else if(x.key==='OPPO'){
            x.color = '#ABD8FF'
           }else if(x.key==='其他'){
            x.color = '#ABD8FC'
           }else if(x.key==='Apple'){
            x.color = '#4D93FF'
           }
          })
          this.equipmentPie.data = data.device_distribution.map(x=>{
            x.name = x.key
            x.value = ((x.value/sum)*100).toFixed(2)
            return x
          })

        }
        if(data.interest_distribution){
          this.interestData = data.interest_distribution
          let sum = 0
          data.interest_distribution.forEach(x=>{
            sum+= x.value
          })
          this.interestBar = {
            xAxis: [],
            data: [
              {
                stack: '兴趣分布',
                color: '#4D93FF',
                barWidth: 20,
                name: '兴趣分布',
                data: [],
                type: 'bar',
                symbol: 'none',
                itemStyle: {
                  borderRadius: [10, 10, 0, 0],
                }
              },
        ],
        custom: {
          legend: false,
          yAxis:{
                    name:'人数',
                    axisLabel:{
                      formatter:'{value}%'
                    }
                  }
        }
          }
          this.interestBar.xAxis = data.interest_distribution.map(x=>x.key).splice(0,9)
          this.interestBar.data[0].data = data.interest_distribution.map(x=>((x.value/sum)*100).toFixed(2)).splice(0,9)
        }
      }
      }).finally(() => {
      })
    },
    getSpectatorBar(){
      let url =`agent-order-5a?starid=${this.accountnumberId}&itemid=${this.vid}&period=${this.agentDay}`
      // if(process.env.NODE_ENV == 'development') {
      //   url= `agent-order-5a?itemid=7219323213640207668&starid=1726877724448775&period=${this.agentDay}`
      // }
      this.$axios.get(url).then(res => {
      // this.$axios.get(`agent-order-5a?itemid=7219323213640207668&starid=1726877724448775&period=${this.agentDay}`).then(res => {
        if(res.data.code!==0){
          this.handleErr(res)
          return
        }
          this.spectatorData = res?.data?.data
            if(this.spectatorData?.modify_time){
              this.spectatorData.modify_time = this.unixTime(this.spectatorData?.modify_time,'YYYY-MM-DD HH:mm:ss')
            }
            if(res?.data?.data?.item_5a_data){
              this.spectatorBar = {
                xAxis: ['了解（Aware，A1）', '吸引（Appeal，A2）', '问询（Ask，A3）', '行动（Action，A4）', '用户（Advocate，A5）', ],
                data: [
                  {
                    stack: '发布前1天',
                    color: '#ECF4FF',
                    barWidth: 20,
                    name: '发布前1天',
                    data: [],
                    type: 'bar',
                    symbol: 'none',
                    itemStyle: {
                      borderRadius: [10, 10, 0, 0],
                    }
                  },
                  {
                    stack: '发布后3天',
                    color: '#4D93FF',
                    barWidth: 20,
                    name: '发布后3天',
                    data: [],
                    type: 'bar',
                    symbol: 'none',
                    itemStyle: {
                      borderRadius: [10, 10, 0, 0],
                    }
                  },
                ],
                custom: {
                  legend:{
                    left:0,
                    itemWidth:13,
                    itemHeigth:10,
                    textStyle:{
                      fontSize:12
                    }
                  }
                }
              }
              let item_5a_data = res?.data?.data?.item_5a_data||{}
              if(res?.data?.data?.item_5a_status == 0){
                this.showfiveA = true
              }else{
                this.showfiveA = false
              }
              if(item_5a_data){
                let arr =['a1','a2','a3','a4','a5']
                let arr1 =['a1','a2','a3_initiative','a4','a5']
                this.a3Over = item_5a_data.over_percent.a3_over
                this.a3InitiativeOver = item_5a_data.over_percent.a3_initiative_over
                if(this.ask){
                  this.spectatorBar.data = this.spectatorBar.data.map((x,i)=>{
                    if(i==0){
                      arr.forEach(y=>{
                        x.data.push(item_5a_data.before[y])
                      })

                    }else if(i==1){
                      arr.forEach(y=>{
                        x.data.push(item_5a_data.after[y])
                      })
                    }
                    return x
                  })
                }else{
                  this.spectatorBar.data = this.spectatorBar.data.map((x,i)=>{
                    if(i==0){
                      arr1.forEach(y=>{
                        x.data.push(item_5a_data.before[y])
                      })
                    }else if(i==1){
                      arr1.forEach(y=>{
                        x.data.push(item_5a_data.after[y])
                      })
                    }
                    return x
                  })
                  this.spectatorBar.xAxis = this.spectatorBar.xAxis.map((x,i)=>{
                      if(i==2){
                        x = '主动问询（Ask，A3）'
                      }
                      return x
                  })
                }
              }
            }
            this.leftPartArr = this.leftPartArr.map(x=>{
              if(x.name == '人群资产' && res?.data?.data?.item_5a_status !== 0){
                x.hide = true
              }
              return x
            })

      }).finally(() => {
      })
    },

    //三位数以上加逗号
    toThousands(num) {
      var num = (num || 0).toString(), result = '';
      while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
      }
      if (num) { result = num + result; }
      return result;
    },
    toChangeW(num){
      if(num > 9999){
        return (Math.floor(num/1000)/10) + 'w'
      }
      return num
    },

  },

  mounted(){
    window.addEventListener("scroll",this.handleScroll);
  },
  destroyed() {
      document.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
.f-c-b{
  display: flex;
  align-items: center;
  justify-content: space-between
}
.page{
  position: relative;
  width: 1820px;
  margin: 20px auto;
  display: flex;
  padding: 30px;
  background-color: #fff;
}
.detailContainer{
  width: 1610px;
  padding-left: 150px;
}
.left_part{
  position: fixed;
  top: 120px;
  left: 30px;
  width: 120px;
  height: 336px;
  background: #FFFFFF;
  border: 1px solid #EFF1F1;
  border-radius: 8px;
}
.left_part_top{
  position: fixed;
  top: 30px;
  left: 30px;
  width: 120px;
  height: 336px;
  background: #FFFFFF;
  border: 1px solid #EFF1F1;
  border-radius: 8px;
}
.infoText{
  width: 100%;
  font-size: 12px;
  font-family: OPPOSans;
  color: #999999;
  padding: 15px 0 30px 0;
}
.orderInfo{
  border-bottom: 1px solid #EFF1F1;
}
.left_part_text {
  display: block;
  text-align: center;
  padding: 7px 12px;
  margin: 13px 20px;
  font-size: 14px;
  font-family: OPPOSans;
  font-weight: 500;
  color: #333333;
}
a.left_part_text:hover,.left_part_active{

  background: #FF5C00;
  text-align: center;
  border-radius: 14px;
  color: #FFFFFF;
}
  .part1 .grade{
    margin-top: 30px;
    width: 100%;
    background: #FFFFFF;
    padding: 30px;
    border: 1px solid #EFF1F1;
    box-sizing: border-box;
    border-radius: 8px;
    line-height: 0px;
  }
  .part1 .grade .title,.synthesize .title,.disseminate .title{
    margin: 10px 0;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
  }
  .part1 .grade .comment{
    width: 100%;
    background: #F8F8F8;
    border-radius: 6px;
    padding: 20px 30px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #888888;
    line-height: 32px;
    margin-bottom:0;
    box-sizing: border-box;
  }

  .part1 .grade .gradeContent{
    width: 100%;
    height: 160px;
  }
  .part1 .grade .gradeContent .scort{
    padding-top: 45px;
    padding-bottom: 40px;
    height: 60px;
    box-sizing: border-box;
    width: 360px;
    margin: 0 auto;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__icon{
    font-size: 60px;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__text{
    font-size: 40px;
  }

  .part1 .grade .gradeContent .tags2{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 390px;
    box-sizing: border-box;

  }

  .part1 .grade .gradeContent .tags2 .tagItem{
    margin-top: 40px;
    width: 260px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(1){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(2){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF9A16;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem img{
    float: left;
    display: inline-block;
    width: 36px;
    height: 36px;
    margin-left: 17px;
    margin-right: 11px;
  }
  .synthesize>>>.el-progress__text{
    font-size: 12px !important;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333 !important;
  }
  .synthesize>>>.el-progress-bar__inner{
    background-image: linear-gradient(to right, #1171FF  0%, #0AA1F8  100%)
  }
  .synthesize_content,.disseminate_content,.touchReach_content,.brand_image_content, .transform_content{
    /* width: 1610px; */
    background: #FFFFFF;
    border: 1px solid #EFF1F1;
    border-radius: 8px;
    padding: 20px 30px 30px 30px;
    margin-bottom: 30px;
  }
  .title_box .title{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    line-height: 32px;
    margin:0px;
  }
  .title_box .subTitle{
    font-size: 14px !important;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    line-height: 32px;
    margin:0px;
  }
  .synthesize_content .content_box{
    display: flex;
  }
  .synthesize_content .title_box .score{
    margin-left: 10px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #FF5C00;
  }
  .synthesize_content .title_box .score_text{
    font-size: 14px;
  }
  .synthesize_content .radar_box{
    width: 340px;
    height: 220px;
    border-right: 1px solid #EFF1F1;
    padding-right: 40px;
  }
  .synthesize_content .progress_box{
    padding: 10px 0 0 40px;
    width: 100%;
  }
  .synthesize_content .grade_box{
    width: calc(100% - 155px) ;
    margin-left: 90px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #666666;
    margin-bottom: 40px;
  }
  .synthesize_content .grade_box:last-child{
    margin-bottom: 0px;
  }
  .synthesize_content .progress_box .progress_item{
   display: flex;
   align-items: center;
   margin-bottom: 8px;
  }
  .progress_box .progress_item .progress_title{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
  }
  .synthesize_content .progress_box .progress{
    display: flex;
    align-items: center;
    width: 92%;
    margin-left: 20px;
    height: 22px;
  }
  .disseminate_content>>>.vxe-radio-group{
    width: 300px;
  }
  .disseminate_content .title_box,.touchReach_content .title_box,.brand_image_content .title_box, .transform_content .title_box{
    display: flex;
    justify-content:space-between;
  }
  .disseminate_mid{
    width: 1550px;
    height: 100px;
    background: #F9F9F9;
    border-radius: 8px;
    display: flex;
    margin-top: 24px;
  }
  .costPerformance_mid{
    width: 100%;
    height: 110px;
  }
  .disseminate_mid_title{
    text-align: center;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
  }
  .disseminate_mid_item{
    position: relative;
    width: 386px;
    padding: 25px 0 35px 0;
  }
  .costPerformance_mid_item{
    position: relative;
    width: 365px;
    padding: 21px 0 17px 0;
  }
  .disseminate_count{
    text-align: center;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
    margin-top: 8px;
  }
  .disseminate_mid_item:after{
    position: absolute;
    content: "";
    width: 1px;
    height: 30px;
    background: #DDDDDD;
    top: 35px;
    /* left: 386px; */
    right: 0;
  }
  .costPerformance_mid_item:after{
    position: absolute;
    content: "";
    width: 1px;
    height: 50px;
    background: #DDDDDD;
    top: 30px;
    left: 100%;
  }
  .disseminate_mid_item:last-child:after,.costPerformance_mid_item:last-child:after{
    display: none;
  }
  .disseminate_content_top{
    display: flex;
    justify-content: space-between;
    padding: 30px 0;
  }
  .disseminate_content .content_box .bar_box{
    width: 100%;
    height: 375px;
  }
  .touchReach_content .touchReach_content_box{
    display: flex;
  }
  .touchReach_content .touchReach_content_box .touchReach_pie{
    width: 310px;
    height: 400px;
  }
  .touchReach_content_box .list_head,.touchReach_content_box .list_item{
    display: flex;
    justify-content:space-between;
    padding: 18px 0;
    border-bottom: 1px solid #EFF1F1;
  }
  .touchReach_content_box .list_box{
    width: calc(100% - 310px);
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
  }
  .touchReach_content_box .list_box .Block{
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 4px;
  }
  .color0{
    background: #1C7CFC;
  }
  .color1{
    background: #3E92FF;
  }
  .color2{
    background: #42A6FE;
  }
  .color3{
    background: #73C2FF;
  }
  .color4{
    background: #88CBFF;
  }
  .color5{
    background: #ABD8FF;
  }
  .color6{
    background: #DBF0FF;
  }
  .fist_block{
    display: flex;
    align-items: center;
  }
  .fist_block .fist_text{
    margin-left: 4px;
  }
  .costPerformance{
   display: flex;
   justify-content: space-between;
  }
  .left_content,.right_content{
    width: calc(calc(100% - 30px) / 2);
    box-sizing: border-box;
    border: 1px solid #EFF1F1;
    padding: 30px;
    border-radius: 8px;
    margin-bottom: 30px;
  }
  .costPerformance_bar{
   height: 260px;
  }
  .viewers_bar{
    margin-top: 20px;
    height: 350px;
  }
 .brand{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    text-align: right;
  }
  .search_bar{
    height: 420px;
  }
  .popularFeelingPie{
    height: 240px;
  }
  .wordCloud{
    margin-top: 80px;
    height: 168px;
  }
  .image_content{
    display: flex;
    justify-content: space-between;
  }
  .appraise_list{
    margin-top: 20px;
    height: 550px;
    overflow-y:scroll;
  }
  .appraise_item{
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }
  .appraise_image{
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .appraise_nick{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .appraise_time{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
    margin-left: 10px;
  }
  .appraise_left, .appraise_rigth{
    display: flex;
    padding-right: 50px;
  }
  .appraise_content{
    padding-top: 5px;
    width: 434px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    margin:0px;
  }
  .heart{
    display: block;
    width: 18px;
    height: 16px;
    background:url('./images/heart.png') no-repeat;
    background-size: 100%;
  }
  .heart_num{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
    margin-left: 12px;
  }
  .midbox{
    margin-left: 12px;
  }
  .transform_box{
    position: relative;
    padding:50px  570px 43px 190px;
  }
  .display_volume{
    position: relative;
    width: 500px;
    height: 90px;
    background: #FAFAFA;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 20px;
  }
  .blue_block{
    display: flex;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    height: 90px;
    /* background: linear-gradient(#0AA1F8,#1171FF); */
    background: linear-gradient(-70deg,transparent 30px,#0AA1F8 0,#1171FF);
  }
  .first_block{
    width: 260px;
  }
  .second_block{
    width: 230px;
  }
  .third_block{
    width: 200px;
  }
  .transform_count{
    text-align: right;
    margin-bottom: 7px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
  }
  .transform_count_box{
    position: absolute;
    right: 30px;
    top: 22px;
  }
  .solid1{
    position: absolute;
    top: 100px;
    left: 690px;
    width: 20px;
    height: 102px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px dashed #1878FC;
    border-right: 1px dashed #1878FC;
    border-bottom: 1px dashed #1878FC;
  }
  .solid2{
    position: absolute;
    top: 216px;
    left: 690px;
    width: 20px;
    height: 102px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px dashed #1878FC;
    border-right: 1px dashed #1878FC;
    border-bottom: 1px dashed #1878FC;
  }
  .solid3{
    position: absolute;
    top: 76px;
    left: 690px;
    width: 196px;
    height: 262px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px dashed #1878FC;
    border-right: 1px dashed #1878FC;
    border-bottom: 1px dashed #1878FC;
  }
  .CTR_block{
    width: 140px;
    height: 100px;
    display: flex;
    justify-content:space-around;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 730px;
    top: 100px;
  }
  .CVR_block{
    width: 140px;
    height: 100px;
    display: flex;
    justify-content:space-around;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 730px;
    top: 216px;
  }
  .PVR_block{
    width: 140px;
    height: 100px;
    display: flex;
    justify-content:space-around;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 917px;
    top: 170px;

  }
  .spectator_box{
    position: relative;
    margin-top: 30px;
    height: 400px;
  }
  .ageBar{
    margin-top: 30px;
    height: 270px;
  }
  .spectator_brand{
    position: absolute;
    top: 0;
    right: 0;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .region_proportion_box{
    margin-top: 16px;
  }
  .region_proportion_item{
    margin-top: 14px;
    display: flex;
    align-items: center;
  }
  .region_proportion_text{
    margin-right: 13px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .proportion_box{
    position: relative;
    display: flex;
    width: 670px;
    height: 18px;
    background: #ECF6FF;
  }
  .proportion_content{
    display: block;
    height: 18px;
    background: linear-gradient(90deg, #40A5FF, #40A5FF);
  }
  .proportion_text{
    position: absolute;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .genderPie{
    height: 240px;
  }
  .interestBar{
    height:360px ;
  }

  .detailContainer>>>.el-tabs__nav-wrap::after{
    background-color:transparent;
    border-bottom: 1px solid #F5F5F6;
  }
  .detailContainer>>>.el-tabs__item{
    color:#999;
  }
  .detailContainer>>>.el-tabs__item.is-active{
    color: #FF5C00;
  }
  .detailContainer>>>.el-tabs__active-bar{
    background-color:#FF5C00;
  }

  .part .hr{
    width: 1200px;
    height: 1px;
    margin-left: -30px;
    border-bottom: 1px solid #F5F5F6;
  }


  .clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clear {
    *zoom: 1;
    /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
  }
  .detailContainer .part{
    width: 100%;
    background: #FFFFFF;
    box-sizing: border-box;
  }
  .detailContainer .part1{
    overflow: hidden;
  }
  .part1 .topName{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .part1 .infoContent{
    display: flex;
    /* width: 100%; */
    margin-top: 30px;
  }
  .part1 .infoContent .backImg{
    position: relative;
    width: 126px;
    height: 168px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
  }
  .part1 .infoContent .backImg::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
  }
  .part1 .infoContent .backImg::after{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 40px;
    height: 40px;
    margin: auto;
    background: url("./images/icon_play.png") no-repeat center;
    background-size: cover;
  }
  .part1 .infoContent .backImg img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .part1 .infoContent .contentDetail{
    /* float: left; */
    margin-left: 30px;
    width: 100%;
  }
  .contentDetail .contentTitle{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    line-height: 32px;
  }
  .part1 .infoContent .contentDetail a{
    display: block;
  }
  .part1 .infoContent .contentDetail p a{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
  .part1 .infoContent .contentDetail span a{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .infoContent .contentBottom{
    display: flex;
    justify-content:space-between;
  }
  .part1 .infoContent .contentBottom .infoItem{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .part1 .infoContent .contentBottom .infoItem span{
    /* width: 140px;
    height: 48px; */
    font-size: 12px;
    color: #333333;

  }
  .part1 .infoContent .contentBottom .infoItem .account{
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .scale{
    color: #999999;
    text-align: center;
    font-size: 12px;
    margin-top: 8px;
  }
  .sub_title{
    color: #999999;
    font-size: 12px;
  }
  .scale .rate,.sub_title .rate{
    color: #FF5C00 !important;
    font-weight: 700;
    margin-left: 2px;
  }


  .part5Chart1Container{
    float: left;
    position: relative;
    width: 50%;
  }
  .part5Chart1Container .left{
    position: absolute;
    bottom: 30px;
    left: 30px;
    width: 12px;
    height: 84px;
    background-image: linear-gradient(to bottom, #38a1ff, #e0f1ff);
  }
  .part5Chart1Container .left::before{
    content: "高";
    position: absolute;
    bottom: 90px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5Chart1Container .left::after{
    content: "低";
    position: absolute;
    bottom: -24px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  #detailPart5Echart1{
    width: 570px;
    height: 260px;

  }
</style>